<script setup lang="ts">

//vue
import { onMounted, reactive, } from "vue";
import config from "@/app.config.json";

//servicos
import * as service from "@/services/BoletosService";
import { addDays, fdata, f2dec, fdataUS, fdataUSS, fdataHora, salvarFiltros, carregarFiltros } from "@/utils/funcoes";

//componentes
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import Pesquisa from "./Pesquisa.vue";
import Loading from "@/components/Loading/index.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import Paginador from "@/components/Paginador/Index.vue";

//janelas
import GerarBoletos from "./GerarBoletos.vue"
import GerarRemessa from "./GerarRemessa.vue"
import ImportarRetorno from "./ImportarRetorno.vue"

import { RouterLink } from "vue-router";

interface configColuna {
    coluna: string,
    exibe: boolean
}

interface BoletoDto extends service.Boleto {
    marcado: boolean
}

var controle = reactive({
    filtros: {
        paginaAtual: 1,
        tamanhoPagina: 1000
    } as service.BoletoFiltros,
    boletos: [] as BoletoDto[],
    boletosRemessa: [] as BoletoDto[],
    boletoId: 0 as number,
    boleto: {} as service.Boleto,
    ordemDirecao: "Desc",
    ordemColuna: "BoletoId",
    totalRegistros: 0,
    marcarTodos: false,
    totais: {
        qtde: 0,
        total: 0,
    },
    colunas: [
        { coluna: "Id", exibe: true },
        { coluna: "Banco", exibe: false },
        { coluna: "Nosso Número", exibe: true },
        { coluna: "Docto Origem", exibe: true },
        { coluna: "Dt Documento", exibe: true },
        { coluna: "Dt. Vencto", exibe: true },
        { coluna: "Cliente", exibe: true },
        { coluna: "Razão social", exibe: true },
        { coluna: "Valor R$", exibe: true },
        { coluna: "Tipo Ocorrência", exibe: true },
        { coluna: "Usuário", exibe: true },
        { coluna: "Sequencial", exibe: true },
        { coluna: "Status", exibe: true },
    ] as configColuna[],

    janColunas: false,
    janDetalhes: false,
    historico: [] as service.BoletoHistoricoDTO[],
    statusHistorico: "",
    erroHistorico: "",

    janGerarBoletos: false,
    janGerarRemessa: false,
    janImportarRetorno: false,

    pesquisando: false,
    loading: false,
    status: "",
    erro: "",

});



onMounted(() => {
    carregarConfig();
})

function salvarConfig() {
    salvarFiltros("boletosColunas", controle.colunas);
    salvarFiltros("boletosFiltros", controle.filtros)
}

function carregarConfig() {
    var colunas = carregarFiltros("boletosColunas") as configColuna[];

    //mescla com a config salva, mantendo o padrao das colunas novas que ainda nao foram salvas
    if (colunas != null) {
        controle.colunas.forEach((padrao) => {
            var salvo = colunas.find(a => a.coluna == padrao.coluna);
            if (salvo != undefined)
                padrao.exibe = salvo.exibe;
        });
    }

    //a coluna Banco passou a ficar oculta por padrao
    var banco = controle.colunas.find(a => a.coluna == "Banco");
    if (banco != undefined)
        banco.exibe = false;

    var filtros2 = carregarFiltros("boletosFiltros");

}

const pesquisar = async (maisFiltros?: any) => {

    controle.erro = "";
    controle.pesquisando = true;
    controle.status = "Pesquisando...";
    controle.boletos = [] as BoletoDto[];

    if (maisFiltros != undefined) {
        controle.filtros.nome = maisFiltros.nome;

        console.log("maisFiltros: ", maisFiltros);

        if (maisFiltros.dataCadIni != null && maisFiltros.dataCadIni != "")
            controle.filtros.dataCadIni = fdataUSS(maisFiltros.dataCadIni);
        else
            controle.filtros.dataCadIni = undefined;

        if (maisFiltros.dataCadFim != null && maisFiltros.dataCadFim != "")
            controle.filtros.dataCadFim = fdataUSS(maisFiltros.dataCadFim);
        else
            controle.filtros.dataCadFim = undefined;

        if (maisFiltros.dataDocIni != null && maisFiltros.dataDocIni != "")
            controle.filtros.dataDocIni = fdataUSS(maisFiltros.dataDocIni);
        else
            controle.filtros.dataDocIni = undefined;

        if (maisFiltros.dataDocFim != null && maisFiltros.dataDocFim != "")
            controle.filtros.dataDocFim = fdataUSS(maisFiltros.dataDocFim);
        else
            controle.filtros.dataDocFim = undefined;

        if (maisFiltros.dataVencIni != null && maisFiltros.dataVencIni != "")
            controle.filtros.dataVencIni = fdataUSS(maisFiltros.dataVencIni);
        else
            controle.filtros.dataVencIni = undefined;

        if (maisFiltros.dataVencFim != null && maisFiltros.dataVencFim != "")
            controle.filtros.dataVencFim = fdataUSS(maisFiltros.dataVencFim);
        else
            controle.filtros.dataVencFim = undefined;

        if (maisFiltros.nossoNumero != null && maisFiltros.nossoNumero != "")
            controle.filtros.nossoNumero = maisFiltros.nossoNumero;
        else
            controle.filtros.nossoNumero = undefined;

        if (maisFiltros.numeroDocumento != null && maisFiltros.numeroDocumento != "")
            controle.filtros.numeroDocumento = maisFiltros.numeroDocumento;
        else
            controle.filtros.numeroDocumento = undefined;

        if (maisFiltros.statusId != null && maisFiltros.statusId != "")
            controle.filtros.statusId = maisFiltros.statusId;
        else
            controle.filtros.statusId = undefined;
    }

    service.obter(controle.filtros)
        .then((r) => {
            controle.pesquisando = false;
            controle.status = "";
            controle.boletos = r.dados as BoletoDto[];
            controle.totalRegistros = r.totalRegistros;

            controle.totais.total = 0;

            controle.boletos.forEach((boleto) => {

                controle.totais.qtde++;

                controle.totais.total += (boleto.valorDocumento ?? 0);


                //marca os boletos que estavam marcados
                // var marcado = controle.marcados.find(a => a.boletoId == boleto.boletoId);
                // if (marcado != undefined && marcado != null) {
                //     console.log("marcado: ", marcado);
                //     boleto.marcado = true;
                // }
            });

            salvarConfig();
        })
        .catch((erro: string) => {
            controle.pesquisando = false;
            controle.erro = erro;
            controle.status = "Erro: " + erro + "<br> Tente novamente mais tarde";
        });
};

function exibeCol(coluna: string) {
    var d = controle.colunas.find(a => a.coluna == coluna);
    return (d != undefined && d.exibe == true);
}

const ordenarPor = (coluna: string) => {
    if (controle.ordemColuna == coluna) {
        if (controle.ordemDirecao == "asc")
            controle.ordemDirecao = "desc";
        else
            controle.ordemDirecao = "asc";
    }
    else
        controle.ordemDirecao = "asc";

    controle.ordemColuna = coluna;

    if (controle.ordemDirecao == "asc")
        controle.boletos = controle.boletos.sort((a, b) => (a[coluna] > b[coluna]) ? 1 : ((b[coluna] > a[coluna]) ? -1 : 0));
    else
        controle.boletos = controle.boletos.sort((a, b) => (a[coluna] < b[coluna]) ? 1 : ((b[coluna] < a[coluna]) ? -1 : 0));
}

function exibirDetalhes(boleto: service.Boleto) {
    controle.boleto = boleto;
    controle.boletoId = boleto.boletoId ?? 0;
    controle.historico = [];
    controle.erroHistorico = "";
    controle.statusHistorico = "Buscando remessas e retornos...";
    controle.janDetalhes = true;

    service.obterHistorico(boleto.boletoId)
        .then((r) => {
            controle.historico = r;
            controle.statusHistorico = "";
        })
        .catch((erro) => {
            controle.erroHistorico = `Erro ao buscar remessas e retornos: ${erro.message || erro}`;
            controle.statusHistorico = "";
        });
}

function dataOuTraco(v: string | null | undefined) {
    return !v || v.startsWith("0001") ? "-" : (fdata(v) ?? "-");
}

function secoesDetalhes(b: service.Boleto) {
    const dt = dataOuTraco;
    const vlr = (v: number | null | undefined) => (v ? `R$ ${f2dec(v)}` : "-");
    const txt = (v: unknown) => (v === null || v === undefined || v === "" ? "-" : String(v));

    return [
        {
            titulo: "Boleto", campos: [
                ["Id", txt(b.boletoId)], ["Status", txt(b.status?.descricao)], ["Cliente", txt(b.clienteId)],
                ["Contrato", txt(b.contratoId)], ["Docto origem", txt(b.numeroDocumento)], ["Parcela", `${txt(b.parcela)} / ${txt(b.totalParcelas)}`],
                ["Nosso número", txt(b.nossoNumero)], ["Seu número", txt(b.seuNumero)], ["Carteira", txt(b.carteira)],
                ["Espécie", `${txt(b.especie)} ${txt(b.especieMod)}`], ["Aceite", b.aceite ? "Sim" : "Não"],
                ["Ocorrência", b.ocorrencia ? `${b.ocorrenciaId} - ${b.ocorrencia.descricao}` : txt(b.ocorrenciaId)],
            ]
        },
        {
            titulo: "Banco", campos: [
                ["Banco", txt(b.banco)], ["Agência", txt(b.agencia)], ["Posto", txt(b.posto)], ["Conta", txt(b.conta)],
            ]
        },
        {
            titulo: "Valores e datas", campos: [
                ["Valor", vlr(b.valorDocumento)], ["Dt documento", dt(b.dataDocumento)], ["Dt vencimento", dt(b.dataVencimento)],
                ["Dt processamento", dt(b.dataProcessamento)], ["Dt baixa", dt(b.dataBaixa)], ["Dt limite pagto", dt(b.dataLimitePagto)],
                ["Desconto", vlr(b.vlrDesconto)], ["Dt desconto", dt(b.dataDesconto)], ["Abatimento", vlr(b.valorAbatimento)],
                ["Dt abatimento", dt(b.dataAbatimento)], ["Mora/juros", vlr(b.valorMoraJuros)], ["Dt mora/juros", dt(b.dataMoraJuros)],
                ["Multa %", txt(b.percMulta || null)], ["Dt multa", dt(b.dataMulta)], ["IOF", vlr(b.valorIOF)],
                ["Outras despesas", vlr(b.valorOutrasDespesas)], ["Dias protesto", txt(b.diasDeProtesto || null)],
                ["Dt protesto", dt(b.dataProtesto)], ["Dias negativação", txt(b.diasDeNegativacao)], ["Dt negativação", dt(b.dataNegativacao)],
            ]
        },
        {
            titulo: "Sacado", campos: [
                ["Nome", txt(b.sacadoNome)], ["CPF/CNPJ", txt(b.sacadoCpfCnpj)], ["E-mail", txt(b.sacadoEmail)],
                ["Endereço", `${txt(b.sacadoLogradouro)}, ${txt(b.sacadoNumero)} ${b.sacadoComplemento ?? ""}`], ["Bairro", txt(b.sacadoBairro)],
                ["Cidade/UF", `${txt(b.sacadoCidade)} / ${txt(b.sacadoUF)}`], ["CEP", txt(b.sacadoCep)],
            ]
        },
        {
            titulo: "Mensagens e pagamento", campos: [
                ["Instrução 1", txt(b.instrucao1)], ["Instrução 2", txt(b.instrucao2)], ["Mensagem", txt(b.mensagemLinhas)],
                ["Linha digitável", txt(b.linhaDigitavel)], ["Código de barras", txt(b.codigoBarras)], ["PIX (EMV)", txt(b.emv)],
            ]
        },
    ];
}

function imprimir(boleto: service.Boleto) {
    if (boleto.boletoId == null || boleto.boletoId == 0) {
        controle.erro = "Boleto inválido";
        return;
    }

    const urlBase = `${config.urlApi}`

    var url = `${urlBase}/Boletos/Ver/${boleto.boletoId}`;

    window.open(url, '_blank');
}

function marcarTodos() {

    controle.boletos.forEach(item => {
        item.marcado = controle.marcarTodos;
    });

    salvarConfig();
}



function atualizarPixSelecionados() {

    const ids = controle.boletos.filter(a => a.marcado == true).map(a => a.boletoId);

    if (ids.length == 0) {
        controle.erro = "Selecione ao menos um boleto para atualizar o PIX.";
        return;
    }

    controle.status = `Atualizando PIX de ${ids.length} boleto(s)...`;
    controle.loading = true;

    service.atualizarPixBoletos(ids)
        .then((r) => {
            const sucesso = r.filter(a => a.sucesso && a.temPix).length;
            const semPix = r.filter(a => a.sucesso && !a.temPix).length;
            const falhas = r.filter(a => !a.sucesso).length;

            controle.status = `PIX atualizado: ${sucesso} com PIX, ${semPix} sem PIX, ${falhas} com erro.`;

            pesquisar();

            setTimeout(() => {
                controle.loading = false;
                controle.status = "";
            }, 5000);
        })
        .catch((erro: string) => {
            controle.erro = "Erro ao atualizar PIX: " + erro;
            controle.loading = false;
        });
}

function consultarNoBanco(boleto: service.Boleto) {

    controle.status = "Consultando no banco...";
    controle.loading = true;
    service.consultarBoletoBanco(boleto.boletoId)
        .then(() => {

            controle.status = "Consulta realizada com sucesso.";

            setTimeout(() => {
                pesquisar();
                controle.loading = false;
                controle.status = "";
            }, 3000);
        })
        .catch((erro: string) => {
            controle.status = "Erro ao gravar ocorrência: " + erro;
            setTimeout(() => {
                controle.loading = false;
                controle.status = "";
            }, 4000);
        });
}

function novaOcorrencia(boleto: service.Boleto, ocorrenciaId: string) {

    controle.status = "Gravando ocorrência...";
    controle.loading = true;
    service.novaOcorrencia({ boletoId: boleto.boletoId, ocorrenciaId: ocorrenciaId } as service.RemessaSolicitarDTO)
        .then(() => {

            controle.status = "Ocorrência gravada com sucesso.";

            setTimeout(() => {
                pesquisar();
                controle.loading = false;
                controle.status = "";
            }, 3000);
        })
        .catch((erro: string) => {
            controle.status = "Erro ao gravar ocorrência: " + erro;
            setTimeout(() => {
                controle.loading = false;
                controle.status = "";
            }, 4000);
        });
}

function cancelar(boleto: service.Boleto) {

    controle.status = "Cancelando boleto...";
    controle.loading = true;
    service.cancelarBoleto(boleto.boletoId)
        .then(() => {

            controle.status = "Boleto cancelado com sucesso.";

            setTimeout(() => {
                pesquisar();
                controle.loading = false;
                controle.status = "";
            }, 3000);
        })
        .catch((erro: string) => {
            controle.status = "Erro ao cancelar boleto: " + erro;
            setTimeout(() => {
                controle.loading = false;
                controle.status = "";
            }, 4000);
        });
}

function registrarBoleto(boleto: service.Boleto) {

    controle.status = "Registrando boleto...";

    controle.loading = true;

    service.registrarBoleto({ boletoId: boleto.boletoId } as service.FiltroBoleto)
        .then(() => {

            controle.status = "Boleto registrado com sucesso.";

            setTimeout(() => {
                pesquisar();
                controle.loading = false;
                controle.status = "";
            }, 3000);
        })
        .catch((erro: string) => {
            controle.status = "Erro ao registrar boleto: " + erro;
            setTimeout(() => {
                controle.loading = false;
                controle.status = "";
            }, 4000);
        });
}

function gerarRemessa() {
    console.log("Gerar remessa");
    controle.boletosRemessa = controle.boletos.filter(a => a.marcado == true);
    controle.janGerarRemessa = true;
}

</script>

<template>
    <Loading :isLoading="controle.loading" :mensagem="controle.status" />

    <BreadCrumb PageTitle="Manutenção de boletos" :items="[{label: 'Inicio', to: '/'}]" />

    <div class="card">
        <div class="card-body">

            <div class="row mb-2">
                <div class="col-md-12">
                    <Pesquisa @onPesquisar="pesquisar"></Pesquisa>
                </div>
            </div>


            <div class="mb-1 text-muted f12px">Total: {{ controle.totalRegistros }} registro(s)</div>

            <div class="col-md-12 div-table-boletos box-table table-responsive">
                <table class="table table-striped table-hover table-bordered table-sm">
                    <thead class="th-fixed">
                        <tr>
                            <th class="text-start" @click="ordenarPor('Pedido')" v-if="exibeCol('Id')">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" :id="`chkMarcarTodos`"
                                        v-model="controle.marcarTodos" @change="marcarTodos">
                                    <label class="form-check-label" :for="`chkMarcarTodos`">
                                        Id
                                    </label>
                                </div>
                            </th>
                            <th class="text-start" @click="ordenarPor('dataPedido')" v-if="exibeCol('Banco')">Banco</th>
                            <th class="text-center" @click="ordenarPor('dataDocumento')" v-if="exibeCol('Dt Documento')">
                                Dt Documento
                            </th>
                            <th class="text-center" @click="ordenarPor('vendedorNome')" v-if="exibeCol('Dt. Vencto')">
                                Dt. Vencto
                            </th>
                            <th class="text-start" @click="ordenarPor('clienteId')" v-if="exibeCol('Nosso Número')">
                                Nosso Número</th>
                            <th class="text-start" @click="ordenarPor('clienteRazao')" v-if="exibeCol('Docto Origem')">
                                Docto</th>
                            <!-- <th class="text-end" @click="ordenarPor('canalDescricao')" v-if="exibeCol('Cliente')">Cliente</th> -->
                            <th class="text-start" @click="ordenarPor('tipoDescricao')" v-if="exibeCol('Razão social')">
                                Razão social</th>
                            <th class="text-end" @click="ordenarPor('nomeCidade')" v-if="exibeCol('Valor R$')">Valor R$
                            </th>
                            <th class="text-start" @click="ordenarPor('transpNome')" v-if="exibeCol('Tipo Ocorrência')">
                                Tipo</th>
                            <th class="text-start" @click="ordenarPor('statusId')" v-if="exibeCol('Status')">Status</th>
                            <th class="text-center">Opções</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-show="controle.pesquisando == true">
                            <td colspan="15" class="text-center">
                                <div class="d-inline">
                                    <i class="fa fa-cog fa-spin"></i>
                                    Pesquisando...
                                </div>
                            </td>
                        </tr>


                        <tr class="col-md-12 text-center table-danger" v-show="controle.erro != ''">
                            <td colspan="15" class="text-center">
                                <div class="d-inline">
                                    <i class="fa fa-exclamation"></i>
                                    {{ controle.erro }}
                                </div>
                                <a class="btn btn-primary btn-sm" @click="pesquisar()">Repetir</a>
                            </td>
                        </tr>

                        <tr v-for="(item, idx) in controle.boletos" :key="idx"
                            :class="item.marcado == true ? 'table-active' : ''"
                            @click="controle.boletoId = item.boletoId; controle.boleto = item">

                            <td class="text-start" data-label="Pedido" v-if="exibeCol('Id')">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" :id="`chkped-${item.boletoId}`"
                                        v-model="item.marcado">
                                    <label class="form-check-label" :for="`chkped-${item.boletoId}`">
                                        {{ item.boletoId }}
                                    </label>
                                </div>
                            </td>
                            <td class="text-start" data-label="Banco" v-if="exibeCol('Banco')">
                                {{ item.banco }}
                            </td>
                            <td class="text-center" data-label="Dt Documento" v-if="exibeCol('Dt Documento')">
                                {{ fdata(item.dataDocumento) }}
                            </td>
                            <td class="text-center" data-label="Dt. Vencto" v-if="exibeCol('Dt. Vencto')">
                                {{ fdata(item.dataVencimento) }}
                            </td>
                            <td class="text-start" data-label="Nosso Número" v-if="exibeCol('Nosso Número')">
                                {{ item.nossoNumero }}
                            </td>
                            <td class="text-start" data-label="Docto Origem" v-if="exibeCol('Docto Origem')">
                                {{ item.numeroDocumento }}
                            </td>
                            <!-- <td class="text-end" data-label="Cliente"  v-if="exibeCol('Cliente')">
                                {{ item.clienteId }} 
                            </td> -->
                            <td class="text-start nowrap-celular" data-label="Razão Social" v-if="exibeCol('Razão social')">
                                {{ item.sacadoNome }}
                            </td>
                            <td class="text-end" data-label="Valor R$" v-if="exibeCol('Valor R$')">
                                R$ {{ f2dec(item.valorDocumento) }}
                            </td>
                            <td class="" data-label="Tipo Ocorrência" v-if="exibeCol('Tipo Ocorrência')">
                                {{ item.ocorrenciaId }} - {{ item.ocorrencia.descricao }}
                            </td>
                            <td class="text-start" data-label="Status">
                                <div class="badge " :class="item.status?.classeCor">
                                    <i :class="item.status?.classeIcone"></i> {{ item.status?.descricao }}
                                </div>
                            </td>
                            <td class="text-center text-nowrap" data-label="Opções">
                                <div class="opcoes">

                                    <a class="btn btn-sm  btn-info me-1" href="javascript:void(0)" @click="exibirDetalhes(item)" title="Ver todos os dados do boleto, remessas e retornos">
                                        <i class="fa fa-search"></i>
                                    </a>

                                    <a class="btn btn-sm  btn-warning me-1" 
                                        title="Imprimir Boleto" 
                                        href="javascript:void(0)" 
                                        v-if="item.status?.podeImprimir"
                                        @click="imprimir(item)">
                                        <i class="fa fa-print"></i>
                                    </a> 

                                    <div class="btn-group">
                                        <a class="dropdown-toggle btn btn-sm  btn-primary" href="#" role="button"
                                            data-bs-toggle="dropdown" aria-expanded="false">
                                            <i class="flaticon-more"></i>
                                        </a>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <a class="dropdown-item" href="javascript:void(0)"
                                                    v-if="item.status?.podeImprimir" @click="imprimir(item)">
                                                    <i class="fa fa-print"></i>
                                                    Imprimir
                                                </a>
                                            </li>
                                             <li>
                                                <a class="dropdown-item" href="javascript:void(0)"
                                                    v-if="item.statusId == 1" @click="cancelar(item)">
                                                    <i class="fa fa-ban"></i>
                                                    Cancelar
                                                </a>
                                            </li>
                                             <li>
                                                <a class="dropdown-item" href="javascript:void(0)"
                                                    v-if="item.status?.podeBaixar" @click="novaOcorrencia(item, '1')">
                                                    <i class="fa fa-download"></i>
                                                    Pedido de baixa
                                                </a>
                                            </li>
                                            <li>
                                                <a class="dropdown-item" href="javascript:void(0)"
                                                    v-if="item.status?.podeRemessa" @click="registrarBoleto(item, '1')">
                                                    <i class="fa fa-file-alt"></i>
                                                    Registrar Boleto Online
                                                </a>
                                            </li>
                                            <li>
                                                <a class="dropdown-item" href="javascript:void(0)"
                                                    v-if="item.status?.podeBaixar" @click="consultarNoBanco(item)">
                                                    <i class="flaticon-bank"></i>
                                                    Consultar no banco
                                                </a>
                                            </li>
                                           
                                            <li>
                                                <a class="dropdown-item" href="javascript:void(0)"
                                                    v-if="item.status?.podeProtestar"
                                                    @click="novaOcorrencia(item, '9')">
                                                    <i class="flaticon-dislike"></i>
                                                    Pedido de protesto
                                                </a>
                                            </li>
                                            <li>
                                                <a class="dropdown-item" href="javascript:void(0)"
                                                    v-if="item.status?.podeSustarProtesto"
                                                    @click="novaOcorrencia(item, '10')">
                                                    <i class="flaticon-cancel"></i>
                                                    Sustar protesto
                                                </a>
                                            </li>
                                            <li>
                                                <a class="dropdown-item" href="javascript:void(0)"
                                                    v-if="item.status?.podeSustarProtesto"
                                                    @click="novaOcorrencia(item, '74')">
                                                    <i class="flaticon-cancel"></i>
                                                    Sustar protesto e Baixar titulo
                                                </a>
                                            </li>
                                            <li>
                                                <a class="dropdown-item" href="javascript:void(0)"
                                                    v-if="item.status?.podeSustarProtesto"
                                                    @click="novaOcorrencia(item, '75')">
                                                    <i class="flaticon-cancel"></i>
                                                    Sustar protesto e Manter em carteira
                                                </a>
                                            </li>
                                       
                                        </ul>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="card-footer">
            <div class="d-flex flex-wrap align-items-center gap-1 mb-2">

                    <a class="btn btn-sm btn-primary" @click="controle.janGerarBoletos = true"
                        title="Gerar boletos">
                        Gerar boletos
                    </a>

                    <a class="btn btn-sm btn-primary" @click="controle.janGerarRemessa = !controle.janGerarRemessa"
                        @gerou="pesquisar()" title="Gerar remessa">
                        <i class="fa fa-upload"></i> Remessa
                    </a>

                    <a class="btn btn-sm btn-primary"
                        @click="controle.janImportarRetorno = !controle.janImportarRetorno" @importou="pesquisar()"
                        title="Importar arquivo de retorno do banco">
                        <i class="fa fa-download"></i> Retorno
                    </a>

                    <a class="btn btn-sm btn-primary" @click="atualizarPixSelecionados()"
                        title="Consulta os boletos marcados no banco e atualiza o código PIX (útil para boletos registrados via remessa/retorno, que não trazem o PIX)">
                        <i class="fa fa-qrcode"></i> Atualizar PIX
                    </a>

                    <RouterLink class="btn btn-sm btn-primary" to="/boletosRemessas" title="Ver remessas">
                        Ver Remessa
                    </RouterLink>

                    <RouterLink class="btn btn-sm btn-primary" to="/boletosRetornos" title="Ver retornos">
                        Ver Retorno
                    </RouterLink>

                    <RouterLink class="btn btn-sm btn-primary" to="/boletos/importarRelatorioBanco"
                        title="Importar relatório de títulos (Vencidos/Liquidados/Baixados) exportado do portal do banco">
                        <i class="fa fa-file-excel"></i> Relatório Banco
                    </RouterLink>

                    <div class="dropup">
                        <button class="btn btn-primary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false" title="Mais opções">
                            <i class="fa fa-tools"></i>
                        </button>
                        <ul class="dropdown-menu">
                            <li>
                                <RouterLink class="dropdown-item" to="/boletos/consultarBanco">Consultar no banco
                                </RouterLink>
                            </li>
                            <li><a class="dropdown-item" @click="controle.janColunas = true"
                                    title="Escolher colunas a exibir">Colunas</a></li>
                        </ul>
                    </div>

                    <RouterLink class="btn btn-sm btn-secondary ms-auto" to="/" title="Fechar">
                        Fechar
                    </RouterLink>

            </div>

            <div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <div class="small">
                    Boletos: [{{ controle.boletos?.length }}] - R$ {{ f2dec(controle.totais?.total) }}
                    &nbsp;|&nbsp;
                    Selecionado: [{{controle.boletos.filter(a => a.marcado == true).length}}] -
                    R$ {{f2dec(controle.boletos.filter(a => a.marcado == true).reduce((total, boleto) =>
                        total + (boleto.valorDocumento ?? 0), 0))}}
                </div>
                <Paginador :paginaAtual="controle.filtros.paginaAtual"
                    :tamanhoPagina="controle.filtros.tamanhoPagina" :totalRegistros="controle.totalRegistros"
                    @on-change="(el) => {
                        controle.filtros.paginaAtual = el.paginaAtual;
                        controle.filtros.tamanhoPagina = el.tamanhoPagina;
                        pesquisar()
                    }" />
            </div>
        </div>
    </div>


    <MsgBox :id="'janColunas'" :titulo="'Colunas'" :exibir="controle.janColunas" @onFechou="controle.janColunas = false"
        :botaoFechar="true">
        <div class="row">
            <div class="col-md-12">
                <div class="form-check" v-for="(item, idx) in controle.colunas" :key="idx">
                    <input class="form-check-input" type="checkbox" :id="`chkcol-${idx}`" v-model="item.exibe"
                        @change="salvarConfig()">
                    <label class="form-check-label" :for="`chkcol-${idx}`">
                        {{ item.coluna }}
                    </label>
                </div>
            </div>
        </div>
    </MsgBox>

    <MsgBox :id="'janDetalhesBoleto'" tamanho="modal-xl" :titulo="'Boleto ' + controle.boletoId"
        :exibir="controle.janDetalhes" @onFechou="controle.janDetalhes = false" :botaoFechar="true">

        <div class="row">
            <div class="col-md-6 mb-2" v-for="(secao, i) in secoesDetalhes(controle.boleto)" :key="i">
                <div class="fw-bold border-bottom mb-1">{{ secao.titulo }}</div>
                <div class="row small" v-for="(campo, j) in secao.campos" :key="j">
                    <div class="col-5 text-muted">{{ campo[0] }}</div>
                    <div class="col-7 text-break">{{ campo[1] }}</div>
                </div>
            </div>
        </div>

        <div class="fw-bold border-bottom mb-1 mt-2">Remessas e retornos</div>
        <div class="table-responsive">
            <table class="table table-sm table-striped table-bordered small mb-1">
                <thead>
                    <tr>
                        <th>Tipo</th>
                        <th>Data</th>
                        <th>Nº</th>
                        <th>Arquivo</th>
                        <th>Ocorrência</th>
                        <th class="text-end">Valor pago</th>
                        <th>Dt crédito</th>
                        <th>Observação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="controle.historico.length == 0">
                        <td colspan="8" class="text-center">Nenhuma remessa ou retorno para este boleto</td>
                    </tr>
                    <tr v-for="(h, idx) in controle.historico" :key="idx">
                        <td><span class="badge" :class="h.tipo == 'Remessa' ? 'bg-primary' : 'bg-success'">{{ h.tipo }}</span></td>
                        <td class="text-nowrap">{{ dataOuTraco(h.data) }}</td>
                        <td>{{ h.numero }}</td>
                        <td>{{ h.arquivo ?? '-' }}</td>
                        <td>{{ h.ocorrenciaId }}{{ h.ocorrencia ? ' - ' + h.ocorrencia : '' }}</td>
                        <td class="text-end">{{ h.valorPago ? f2dec(h.valorPago) : '-' }}</td>
                        <td class="text-nowrap">{{ h.tipo == 'Retorno' ? dataOuTraco(h.dataCredito) : '-' }}</td>
                        <td>{{ h.observacao ?? '' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="text-center">
            <span>{{ controle.statusHistorico }}</span>
            <span class="text-danger fw-bold">{{ controle.erroHistorico }}</span>
        </div>
    </MsgBox>

    <GerarBoletos @gerou="pesquisar()" :exibir="controle.janGerarBoletos" @fechou="controle.janGerarBoletos = false" />


    <GerarRemessa :boletos="controle.boletos.filter(a => a.marcado == true)" :exibir="controle.janGerarRemessa"
        @fechou="controle.janGerarRemessa = false" @gerou="pesquisar()" />

    <ImportarRetorno :exibir="controle.janImportarRetorno" @fechou="controle.janImportarRetorno = false"
        @importou="pesquisar()" />

</template>

<style scoped>
.div-table-boletos {
    max-height: calc(100vh - 350px);
    min-height: calc(100vh - 350px);
    overflow: auto;
}

.badge {
    font-size: 100%;
    cursor: pointer;
    text-wrap: wrap;
}

.table-selecao {
    color: #fff !important;
    background-color: #003b93 !important;
    --bs-table-bg-state: #0d6efd;
    --bs-table-color-state: #fff;
}

.opcoes {
    min-width: 95px;
}

/* Evita quebra de linha nas colunas de nome/telefone apenas no celular */
@media (max-width: 767.98px) {
    .nowrap-celular {
        white-space: nowrap;
    }
}
</style>